export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  category: string;
  year: number;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  coverImage: string;
  bannerImage: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateDate: string;
  views: number;
}

export const categories = [
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line" },
  { slug: "anime", name: "动漫", icon: "ri-emotion-line" },
  { slug: "variety", name: "综艺", icon: "ri-mic-line" },
];

export const movies: Movie[] = [
  {
    id: "m1",
    title: "流浪地球3",
    originalTitle: "The Wandering Earth 3",
    category: "movie",
    year: 2026,
    rating: 8.9,
    duration: "148分钟",
    region: "中国大陆",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健"],
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，人类命运共同体将如何抉择？流浪地球3将带领观众进入更加宏大壮丽的星际冒险。",
    coverImage: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20The%20Wandering%20Earth%203%2C%20epic%20sci-fi%20style%2C%20giant%20planet%20engines%20glowing%20warm%20orange%20light%2C%20deep%20space%20background%20with%20stars%2C%20dramatic%20composition%2C%20cinematic%20lighting%2C%20movie%20poster%20aesthetic%2C%20warm%20tone%2C%20no%20text%2C%20clean%20cinematic%20look&width=600&height=840&seq=movie-cover-m1&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20banner%20for%20The%20Wandering%20Earth%203%2C%20massive%20planet%20engines%20in%20deep%20space%2C%20warm%20orange%20and%20golden%20glow%2C%20dramatic%20cinematic%20lighting%2C%20epic%20scale%2C%20atmospheric%20and%20heroic%20mood%2C%20cinematic%20photography%20style&width=1400&height=600&seq=movie-banner-m1&orientation=landscape",
    tags: ["科幻", "冒险", "灾难"],
    isHot: true,
    isNew: true,
    updateDate: "2026-08-01",
    views: 12580000,
  },
  {
    id: "m2",
    title: "封神第二部",
    originalTitle: "Creation of the Gods II",
    category: "movie",
    year: 2026,
    rating: 9.1,
    duration: "156分钟",
    region: "中国大陆",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适"],
    description: "封神第二部延续前作的宏大叙事，商周交替之际，人仙魔三界大战一触即发。姜子牙率领众神迎战纣王大军，史诗级东方奇幻巨制震撼来袭。",
    coverImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20movie%20poster%20for%20Creation%20of%20the%20Gods%20II%2C%20ancient%20Chinese%20warriors%20in%20elaborate%20armor%2C%20mythical%20creatures%2C%20golden%20and%20crimson%20tones%2C%20dramatic%20cinematic%20lighting%2C%20epic%20fantasy%20aesthetic%2C%20warm%20rich%20colors%2C%20no%20text&width=600&height=840&seq=movie-cover-m2&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20banner%2C%20ancient%20Chinese%20warriors%20and%20mythical%20beasts%20in%20dramatic%20battle%2C%20golden%20and%20crimson%20atmosphere%2C%20cinematic%20epic%20scale%2C%20warm%20dramatic%20lighting%2C%20heroic%20composition&width=1400&height=600&seq=movie-banner-m2&orientation=landscape",
    tags: ["奇幻", "史诗", "神话"],
    isHot: true,
    isNew: false,
    updateDate: "2026-07-20",
    views: 9800000,
  },
  {
    id: "m3",
    title: "哪吒之魔童闹海",
    originalTitle: "Nezha: The Devil Child Rages",
    category: "movie",
    year: 2026,
    rating: 9.3,
    duration: "132分钟",
    region: "中国大陆",
    director: "饺子",
    actors: ["吕艳婷", "囧森瑟夫", "瀚墨"],
    description: "天劫之后，哪吒与敖丙的命运再次交织。面对天庭的追责与众生的误解，哪吒将如何打破命运的枷锁？国产动画巅峰之作，视觉与情感的双重震撼。",
    coverImage: "https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20for%20Nezha%20Chinese%20animation%2C%20fiery%20young%20warrior%20with%20flaming%20wheels%2C%20dramatic%20red%20and%20golden%20color%20palette%2C%20epic%20anime%20style%2C%20dynamic%20pose%2C%20warm%20dramatic%20lighting%2C%20cinematic%20animation%20aesthetic%2C%20no%20text&width=600&height=840&seq=movie-cover-m3&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20animated%20film%20banner%20with%20Nezha%20riding%20flaming%20wheels%20across%20stormy%20seas%2C%20dramatic%20red%20and%20golden%20atmosphere%2C%20mythical%20Chinese%20animation%20style%2C%20cinematic%20lighting%2C%20heroic%20and%20emotional%20mood&width=1400&height=600&seq=movie-banner-m3&orientation=landscape",
    tags: ["动画", "奇幻", "神话"],
    isHot: true,
    isNew: true,
    updateDate: "2026-08-02",
    views: 15600000,
  },
  {
    id: "m4",
    title: "志愿军：雄兵出击2",
    originalTitle: "The Volunteers: To the War 2",
    category: "movie",
    year: 2026,
    rating: 8.7,
    duration: "162分钟",
    region: "中国大陆",
    director: "陈凯歌",
    actors: ["唐国强", "刘劲", "王伍福"],
    description: "抗美援朝战争进入关键阶段，志愿军将士在极端恶劣的条件下浴血奋战。本片以恢弘的战争场面和深刻的人文关怀，再现了那段可歌可泣的历史。",
    coverImage: "https://readdy.ai/api/search-image?query=War%20movie%20poster%20for%20The%20Volunteers%20Korean%20War%20film%2C%20soldiers%20in%20heroic%20pose%20during%20winter%20battle%2C%20dramatic%20cinematic%20lighting%2C%20warm%20earthy%20tones%2C%20patriotic%20and%20heroic%20aesthetic%2C%20epic%20war%20film%20style%2C%20no%20text&width=600&height=840&seq=movie-cover-m4&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20war%20film%20banner%20showing%20heroic%20soldiers%20advancing%20through%20winter%20battlefield%2C%20dramatic%20smoke%20and%20snow%2C%20warm%20golden%20light%20breaking%20through%2C%20cinematic%20scale%2C%20heroic%20and%20emotional%20composition&width=1400&height=600&seq=movie-banner-m4&orientation=landscape",
    tags: ["战争", "历史", "剧情"],
    isHot: true,
    isNew: false,
    updateDate: "2026-07-15",
    views: 11200000,
  },
  {
    id: "m5",
    title: "孤注一掷2",
    originalTitle: "No More Bets 2",
    category: "movie",
    year: 2026,
    rating: 8.5,
    duration: "128分钟",
    region: "中国大陆",
    director: "申奥",
    actors: ["张艺兴", "金晨", "咏梅"],
    description: "续作聚焦跨国网络犯罪的新战场，深入揭露暗网背后的黑色产业链。正义与邪恶的较量在虚拟与现实之间展开，紧张刺激的剧情让人屏息。",
    coverImage: "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20for%20No%20More%20Bets%202%2C%20dark%20mysterious%20atmosphere%2C%20digital%20code%20and%20human%20silhouette%2C%20warm%20amber%20and%20dark%20contrast%20lighting%2C%20suspenseful%20cinematic%20aesthetic%2C%20modern%20thriller%20style%2C%20no%20text&width=600&height=840&seq=movie-cover-m5&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Suspenseful%20crime%20thriller%20banner%2C%20dark%20urban%20night%20scene%20with%20digital%20code%20overlay%2C%20warm%20amber%20streetlights%20contrasting%20dark%20shadows%2C%20cinematic%20noir%20atmosphere%2C%20mysterious%20and%20tense%20mood&width=1400&height=600&seq=movie-banner-m5&orientation=landscape",
    tags: ["犯罪", "悬疑", "剧情"],
    isHot: false,
    isNew: true,
    updateDate: "2026-08-03",
    views: 7800000,
  },
  {
    id: "m6",
    title: "白蛇：浮生",
    originalTitle: "White Snake: Floating Life",
    category: "movie",
    year: 2026,
    rating: 8.8,
    duration: "140分钟",
    region: "中国大陆",
    director: "黄家康",
    actors: ["张喆", "杨天翔", "唐小喜"],
    description: "白蛇系列第三部，讲述白素贞与许仙前世今生的爱恋纠葛。精美的国风动画画面，配合感人至深的爱情故事，再次打动无数观众的心。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20for%20White%20Snake%20love%20story%2C%20elegant%20white%20snake%20spirit%20in%20traditional%20Chinese%20setting%2C%20soft%20warm%20lighting%2C%20romantic%20and%20ethereal%20aesthetic%2C%20ink%20wash%20painting%20style%20animation%2C%20dreamy%20atmosphere%2C%20no%20text&width=600&height=840&seq=movie-cover-m6&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20animation%20banner%2C%20elegant%20white%20snake%20spirit%20dancing%20among%20cherry%20blossoms%2C%20traditional%20Chinese%20landscape%2C%20soft%20warm%20pink%20and%20golden%20light%2C%20ethereal%20and%20dreamy%20atmosphere%2C%20ink%20wash%20painting%20style&width=1400&height=600&seq=movie-banner-m6&orientation=landscape",
    tags: ["动画", "爱情", "奇幻"],
    isHot: true,
    isNew: true,
    updateDate: "2026-07-30",
    views: 8900000,
  },
  {
    id: "m7",
    title: "庆余年第二季",
    originalTitle: "Joy of Life Season 2",
    category: "tv",
    year: 2026,
    rating: 9.2,
    duration: "45分钟/集 共36集",
    region: "中国大陆",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明"],
    description: "范闲从北齐归来，却发现京都暗流涌动，各方势力蠢蠢欲动。面对更加复杂的朝堂斗争，范闲将如何在刀光剑影中守护所爱之人？",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20for%20Joy%20of%20Life%20Season%202%2C%20elegant%20man%20in%20traditional%20Hanfu%20costume%2C%20palace%20intrigue%20atmosphere%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text&width=600&height=840&seq=movie-cover-m7&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20banner%2C%20ancient%20Chinese%20palace%20interior%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20candlelight%20atmosphere%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20cinematic%20composition&width=1400&height=600&seq=movie-banner-m7&orientation=landscape",
    tags: ["古装", "权谋", "剧情"],
    isHot: true,
    isNew: true,
    updateDate: "2026-08-01",
    views: 22000000,
  },
  {
    id: "m8",
    title: "长相思第二季",
    originalTitle: "Lost You Forever S2",
    category: "tv",
    year: 2026,
    rating: 8.6,
    duration: "45分钟/集 共39集",
    region: "中国大陆",
    director: "秦榛",
    actors: ["杨紫", "张晚意", "邓为"],
    description: "小夭的身世之谜逐渐揭开，三段刻骨铭心的情感纠葛在神族与人族的宏大背景下交织。爱与牺牲、守护与成全，谁才是她命中注定的那个人？",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20TV%20drama%20poster%2C%20beautiful%20woman%20in%20flowing%20ancient%20Chinese%20dress%2C%20ethereal%20mythical%20atmosphere%2C%20soft%20warm%20peach%20and%20golden%20lighting%2C%20romantic%20cinematic%20style%2C%20no%20text&width=600&height=840&seq=movie-cover-m8&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Romantic%20Chinese%20fantasy%20drama%20banner%2C%20ethereal%20garden%20with%20cherry%20blossoms%20and%20ancient%20pavilions%2C%20soft%20warm%20golden%20sunset%20light%2C%20dreamy%20and%20romantic%20atmosphere%2C%20mythical%20Chinese%20aesthetic&width=1400&height=600&seq=movie-banner-m8&orientation=landscape",
    tags: ["古装", "爱情", "奇幻"],
    isHot: true,
    isNew: false,
    updateDate: "2026-07-18",
    views: 18500000,
  },
  {
    id: "m9",
    title: "斗罗大陆之绝世唐门",
    originalTitle: "Soul Land: The Peerless Tang Sect",
    category: "anime",
    year: 2026,
    rating: 9.0,
    duration: "20分钟/集 更新至156集",
    region: "中国大陆",
    director: "沈乐平",
    actors: ["沈磊", "冯骏骅", "杨梦露"],
    description: "霍雨浩带着母亲的遗愿来到史莱克学院，在这个天才云集的地方，他将如何凭借自己的努力和不屈的意志闯出一片天地？斗罗大陆系列最新力作。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20for%20Soul%20Land%20series%2C%20young%20hero%20with%20glowing%20spirit%20ring%2C%20fantasy%20martial%20arts%20style%2C%20warm%20golden%20and%20emerald%20energy%20effects%2C%20dynamic%20action%20pose%2C%20epic%20anime%20aesthetic%2C%20no%20text&width=600&height=840&seq=movie-cover-m9&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20Chinese%203D%20anime%20banner%2C%20fantasy%20academy%20campus%20with%20floating%20islands%20and%20glowing%20energy%2C%20warm%20golden%20sunlight%20and%20magical%20atmosphere%2C%20dynamic%20and%20heroic%20composition%2C%20anime%20cinematic%20style&width=1400&height=600&seq=movie-banner-m9&orientation=landscape",
    tags: ["动画", "玄幻", "热血"],
    isHot: true,
    isNew: false,
    updateDate: "2026-07-25",
    views: 16800000,
  },
  {
    id: "m10",
    title: "繁花",
    originalTitle: "Blossoms Shanghai",
    category: "tv",
    year: 2026,
    rating: 9.4,
    duration: "45分钟/集 共30集",
    region: "中国大陆",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣"],
    description: "九十年代的上海，处处是机遇与挑战。阿宝在时代的浪潮中从平凡青年成长为商界巨擘，一段关于梦想、爱情与人生的传奇故事。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20poster%20for%20Blossoms%20Shanghai%2C%20elegant%20man%20in%201990s%20vintage%20suit%2C%20Shanghai%20cityscape%20background%2C%20warm%20golden%20and%20amber%20nostalgic%20lighting%2C%20cinematic%20retro%20aesthetic%2C%20no%20text&width=600&height=840&seq=movie-cover-m10&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Nostalgic%201990s%20Shanghai%20cityscape%20banner%2C%20the%20Bund%20at%20sunset%20with%20warm%20golden%20light%2C%20vintage%20cars%20and%20neon%20signs%2C%20cinematic%20retro%20aesthetic%2C%20romantic%20and%20melancholic%20atmosphere&width=1400&height=600&seq=movie-banner-m10&orientation=landscape",
    tags: ["年代", "商战", "爱情"],
    isHot: true,
    isNew: false,
    updateDate: "2026-07-10",
    views: 25000000,
  },
  {
    id: "m11",
    title: "咒术回战 第三季",
    originalTitle: "Jujutsu Kaisen S3",
    category: "anime",
    year: 2026,
    rating: 9.1,
    duration: "24分钟/集 更新至12集",
    region: "日本",
    director: "朴性厚",
    actors: ["榎木淳弥", "内田雄马", "濑户麻沙美"],
    description: "涩谷事变之后，咒术界陷入前所未有的危机。虎杖悠仁与伙伴们面对更加强大的诅咒，将如何在绝望中寻找希望？热血与感动交织的王道少年漫。",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20for%20Jujutsu%20Kaisen%20Season%203%2C%20dynamic%20action%20pose%20with%20dark%20energy%20effects%2C%20warm%20orange%20and%20dark%20purple%20contrast%2C%20intense%20anime%20fighting%20style%2C%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=movie-cover-m11&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Epic%20Japanese%20anime%20banner%20with%20intense%20battle%20scene%2C%20dark%20urban%20setting%20with%20glowing%20cursed%20energy%2C%20warm%20orange%20and%20dark%20dramatic%20atmosphere%2C%20dynamic%20action%20composition%2C%20cinematic%20anime%20style&width=1400&height=600&seq=movie-banner-m11&orientation=landscape",
    tags: ["动画", "热血", "战斗"],
    isHot: true,
    isNew: true,
    updateDate: "2026-08-02",
    views: 13500000,
  },
  {
    id: "m12",
    title: "乘风破浪的姐姐 第五季",
    originalTitle: "Sisters Who Make Waves S5",
    category: "variety",
    year: 2026,
    rating: 8.2,
    duration: "120分钟/期 更新至8期",
    region: "中国大陆",
    director: "吴梦知",
    actors: ["宁静", "那英", "王心凌"],
    description: "三十位30+姐姐再度集结，用实力打破年龄的偏见。从唱跳舞台到人生感悟，她们用汗水与热爱诠释了女性的无限可能。",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20for%20Sisters%20Who%20Make%20Waves%2C%20elegant%20women%20on%20glamorous%20stage%20with%20sparkling%20lights%2C%20warm%20golden%20and%20rose%20tones%2C%20celebrity%20show%20aesthetic%2C%20glamorous%20and%20confident%20mood%2C%20no%20text&width=600&height=840&seq=movie-cover-m12&orientation=portrait",
    bannerImage: "https://readdy.ai/api/search-image?query=Glamorous%20variety%20show%20stage%20banner%2C%20women%20performers%20on%20sparkling%20stage%20with%20golden%20spotlights%2C%20warm%20and%20energetic%20atmosphere%2C%20celebratory%20and%20empowering%20mood%2C%20cinematic%20entertainment%20photography&width=1400&height=600&seq=movie-banner-m12&orientation=landscape",
    tags: ["综艺", "音乐", "真人秀"],
    isHot: false,
    isNew: true,
    updateDate: "2026-08-03",
    views: 5600000,
  },
];